import { GLOBAL_CONFIG } from '../constants/global.config'
import { DomainConfig } from '../types'

const config: DomainConfig = {
  ...GLOBAL_CONFIG,
  APP_KEY: 'ZMB',
  CLIENT_ID: '12',
  COUNTRY: 'zm'
}

export default config
